module.exports = __webpack_public_path__ + "static/CreateDatabase-375ca14d854e7cea36c1c76faabc13a3.png";